const readableFileType = (fileType: string): string => {
  switch (fileType) {
    case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
      return 'xlsx'
    case 'application/vnd.ms-excel':
      return 'xls'
    case 'text/csv':
      return 'csv'
    default:
      return fileType
  }
}

export const readableFileTypes = (fileType: string | string[]): string[] => {
  const fileTypes = Array.isArray(fileType) ? fileType : [fileType]

  return fileTypes.map(readableFileType)
}
